import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
});

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

export const InstallButton = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const h = () => force((x) => x + 1);
    window.addEventListener("beforeinstallprompt", h);
    window.addEventListener("appinstalled", h);
    return () => {
      window.removeEventListener("beforeinstallprompt", h);
      window.removeEventListener("appinstalled", h);
    };
  }, []);
  if (isStandalone()) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      deferred = null;
      force((x) => x + 1);
    } else {
      toast.info("Instal aplikasi", {
        description: "Chrome/Edge: klik ikon instal di address bar atau menu ⋮ > Instal aplikasi. iPhone (Safari): Bagikan > Tambah ke Layar Utama.",
        duration: 8000,
      });
    }
  };
  return (
    <Button variant="outline" size="sm" className="rounded-full gap-2" onClick={install} data-testid="install-app-btn">
      <Download className="h-4 w-4" />
      <span className="hidden md:inline">Instal App</span>
    </Button>
  );
};
